import { URL_REPLACEMENT } from '$const';
import { get, patch, patchMultiple, post, remove } from '~services/api/methods';
import { isEmpty } from '~utils/object';

export enum UsergroupApiKeysEnum {
  SearchUser = 'searchUser',
  SearchUsers = 'searchUsers',
  GetUsergroup = 'getUsergroup',
  GetUsergroups = 'getUsergroups',
}

function sanitizeUrlParameter(param: string) {
  return param.replaceAll('/', '%26%2347%3B');
}

export const getSearchUser = async (searchTerm: string) => {
  if (!searchTerm) {
    return [];
  }
  const response = await get<UserSearchDto>(
    `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/users/search/${sanitizeUrlParameter(searchTerm)}`,
  );
  // ToDo: add validation! see api/validators/*
  if (isEmpty(response.result)) {
    return [];
  }
  return Array.isArray(response.result) ? response.result : [response.result]; // Make sure to return an array
};

export const getSearchUsers = async (searchTerm: string) => {
  if (!searchTerm) {
    return [];
  }

  const params = new URLSearchParams();
  params.append('q', searchTerm.toLowerCase().trim());
  params.append('startIndex', '0');
  params.append('count', '99');
  // sortBy: 'name' // default: 'name'
  // sortOrder: 'asc', // 'asc' | 'desc'
  params.append('extraFields', '<defaults>');

  const response = await get<UserSearchDto>(`${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/users?${params}`);
  // ToDo: add validation! see api/validators/*
  if (isEmpty(response.result)) {
    return [];
  }
  return Array.isArray(response.result) ? response.result : [response.result]; // Make sure to return an array
};

export const getUsergroups = async () => {
  const response = await get<UsergroupsDto>(`${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups`);
  // ToDo: add validation! see api/validators/*
  // Sort alphabetically by name
  return [...response.groups].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
};

export const getUsergroup = async (groupName: string) => {
  const response = await get<UsergroupShape>(
    `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups/${sanitizeUrlParameter(groupName)}`,
  );
  // ToDo: add validation! see api/validators/*
  return response;
};

export const createUsergroup = async (usergroup: UsergroupDto) => {
  const response = await post<UsergroupPatchDto>(`${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups`, usergroup, {
    useXwwwFormUrlencoded: true,
  });
  // ToDo: add validation! see api/validators/*
  return response;
};

export const deleteUsergroup = async (groupName: string) => {
  const response = await remove<UsergroupPatchDto>(
    `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups/${sanitizeUrlParameter(groupName)}`,
  );
  // ToDo: add validation! see api/validators/*
  return response;
};

export const renameUsergroup = async ({ groupName, newGroupName }: { groupName: string; newGroupName: string }) => {
  const response = await patch<UsergroupPatchDto>(
    `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups/${sanitizeUrlParameter(
      groupName,
    )}/rename/${sanitizeUrlParameter(newGroupName)}`,
  );
  // ToDo: add validation! see api/validators/*
  return response;
};

export const addUserToUsergroup = async ({ groupName, userName }: { groupName: string; userName: string }) => {
  const response = await patch<UsergroupPatchDto>(
    `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups/${sanitizeUrlParameter(groupName)}/add_member/${userName}`,
  );
  // ToDo: add validation! see api/validators/*
  return response;
};

export const addUsersToUsergroup = async ({ groupName, userNames }: { groupName: string; userNames: string[] }) => {
  const configs = userNames.map(userName => ({
    url: `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups/${sanitizeUrlParameter(groupName)}/add_member/${userName}`,
  }));
  const response = await patchMultiple<Array<UsergroupPatchDto>>(...configs);
  // ToDo: add validation! see api/validators/*
  return response;
};

export const removeUserFromUsergroup = async ({ groupName, userName }: { groupName: string; userName: string }) => {
  const response = await patch<UsergroupPatchDto>(
    `${URL_REPLACEMENT.BACKEND_URL}/api/ebm_user/groups/${sanitizeUrlParameter(groupName)}/remove_member/${userName}`,
    undefined,
  );
  // ToDo: add validation! see api/validators/*
  return response;
};
